(function () {
  "use strict";

  const whatsappHosts = new Set([
    "wa.me",
    "api.whatsapp.com",
    "web.whatsapp.com",
    "walink.co",
    "w.app"
  ]);

  document.addEventListener("click", function (event) {
    const target = event.target instanceof Element ? event.target : null;
    const link = target && target.closest("a[href]");
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }
    if (!whatsappHosts.has(url.hostname.toLowerCase())) return;

    const publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
    if (typeof publish !== "function") return;

    try {
      const location = window.location.pathname.startsWith("/products/") ? "product" : "sitewide";
      const result = publish.call(window.Shopify.analytics, "newton_whatsapp_clicked", {
        cta_kind: "whatsapp",
        cta_location: location
      });
      if (result && typeof result.catch === "function") result.catch(function () {});
    } catch (_) {
      // Never interrupt the store's navigation for a measurement event.
    }
  }, true);
})();
